define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityTypeDomain = void 0;
    class FacilityTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityTypeDomain.ArtesianWater, value: "Artesian Water" },
                    { key: FacilityTypeDomain.ExcavatedTank, value: "Excavated Tank" },
                    { key: FacilityTypeDomain.Excavation, value: "Excavation" },
                    { key: FacilityTypeDomain.NaturalWaterhole, value: "Natural Waterhole" },
                    { key: FacilityTypeDomain.SubArtesianWater, value: "Sub-artesian Water" },
                    { key: FacilityTypeDomain.BoreDrain, value: "Bore Drain" },
                    { key: FacilityTypeDomain.NonWaterFacility, value: "Non-Water Facility" },
                    { key: FacilityTypeDomain.UnknownWaterSource, value: "Unknown water source" },
                    { key: FacilityTypeDomain.TownWater, value: "Town Water" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityTypeDomain.ArtesianWater] = 0;
                this.KeyIndex[FacilityTypeDomain.ExcavatedTank] = 1;
                this.KeyIndex[FacilityTypeDomain.Excavation] = 2;
                this.KeyIndex[FacilityTypeDomain.NaturalWaterhole] = 3;
                this.KeyIndex[FacilityTypeDomain.SubArtesianWater] = 4;
                this.KeyIndex[FacilityTypeDomain.BoreDrain] = 5;
                this.KeyIndex[FacilityTypeDomain.NonWaterFacility] = 6;
                this.KeyIndex[FacilityTypeDomain.UnknownWaterSource] = 7;
                this.KeyIndex[FacilityTypeDomain.TownWater] = 8;
                this.ValueIndex = {};
                this.ValueIndex["Artesian Water"] = 0;
                this.ValueIndex["Excavated Tank"] = 1;
                this.ValueIndex["Excavation"] = 2;
                this.ValueIndex["Natural Waterhole"] = 3;
                this.ValueIndex["Sub-artesian Water"] = 4;
                this.ValueIndex["Bore Drain"] = 5;
                this.ValueIndex["Non-Water Facility"] = 6;
                this.ValueIndex["Unknown water source"] = 7;
                this.ValueIndex["Town Water"] = 8;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityTypeDomain = FacilityTypeDomain;
    Object.defineProperty(FacilityTypeDomain, "ArtesianWater", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityTypeDomain, "ExcavatedTank", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityTypeDomain, "Excavation", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityTypeDomain, "NaturalWaterhole", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FacilityTypeDomain, "SubArtesianWater", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FacilityTypeDomain, "BoreDrain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(FacilityTypeDomain, "NonWaterFacility", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(FacilityTypeDomain, "UnknownWaterSource", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(FacilityTypeDomain, "TownWater", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(FacilityTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
